module.exports = __webpack_public_path__ + "img/SKLB-Estadisticas.b59f0dee.png";